var React = require('react');
var ReactNative = require('react-native');


var Animated = require('./wrappers/Animated')

import Icon from './wrappers/ReUpIcon';

var ReUpScrollView = require('./ReUpScrollView.js');
var ShadowView = require('./ShadowView.js');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager.js');
var ModelConstants = require('./constants/ModelConstants.js');
var PaymentMethodChooserView = require('./PaymentMethodChooserView.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton
} = MK;

var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText.js');

var FeedCard = require('./feedCard.js');

var {
  AppRegistry,
  StyleSheet,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  NativeAppEventEmitter,
  Platform,
  Animated
} = ReactNative;

var AddPass = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      extras: {}
    }
  },

  getInitialState : function()
  {
    var appManager = this.props.appManager;
    var user = appManager.currentUser();
    var locManager = this.props.appManager.getLocalizationManager();

    return {
      layout : this.props.initialLayout,
      user:user,
      purchaseButtonTitle:"Purchase - " + locManager.localizedDollars(this.props.extras.pass.AmountCharged),
      refreshDisabled:false
    }
  },

  submit : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    var transactionConfirmTitle = locManager.localizedStringForKey("ADDPASSS_CONFIRM_ALERT_TITLE");
    var transactionConfirmBody = locManager.localizedStringForKey("ADDPASS_CONFIRM_ALERT_BODY");
    var yesText = locManager.localizedStringForKey("YES_ALERT_BUTTON");
    var noText = locManager.localizedStringForKey("NO_ALERT_BUTTON");

    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");

    var paymentSuccessTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_TITLE");
    var paymentSuccessBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_BODY");
    var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");

    var paymentFailTitle = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_TITLE");
    var paymentFailBody = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_BODY");
    appActions.showAlert(transactionConfirmTitle,transactionConfirmBody,[noText, yesText],[appActions.hideAlert, function()
    {
      appActions.hideAlert();
      appActions.setSpinnerShown(true, processingHUD);
      var paymentMethodChooser = thisThing.refs.paymentMethod;
      var paymentMethod = paymentMethodChooser.getPrimaryPaymentMethod();
      NetworkManager.submitPassPayment( appManager, thisThing.props.extras.pass.PassID, paymentMethod, function(data)
      {
        appActions.setSpinnerShown(false);
        var user = appManager.currentUser();
        appManager.setCurrentUser(user, function()
        {
          appActions.showAlert(paymentSuccessTitle,paymentSuccessBody,[okayText],[function(){appActions.requestPop(false);thisThing.props.extras.passes.refs.ptr.doOnlineUpdate(); appActions.hideAlert();}]);
        });
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showAlert(paymentFailTitle,paymentFailBody,[okayText]);
      }, function(data)
      {
        appActions.setSpinnerShown(false);
        appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
      })
    }, appActions.hideAlert], function(){})
  },

  pullToRefreshView: function()
  {
    return this.refs.ptr
  },

  update: function()
  {

  },

  didUpdate: function(data)
  {
    var thisThing = this;
    this.props.appManager.getCurrentUser(function(user)
    {
      thisThing.setState({user:user});
    })
  },

  render: function()
  {
    var AddPass = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();
    var credit = parseFloat(user[ModelConstants.Credits]);

    var instructionColor = appManager.getColorForKey("InstructionColor");
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
    var purchaseButtonTitle = this.state.purchaseButtonTitle;

    var paymentInfo = appManager.getPaymentInfo();
    var hasPrimaryPaymentMethod = false;
    for( var i = 0; i < paymentInfo.length; i++ )
    {
      if( paymentInfo[i].isPrimary )
      {
        hasPrimaryPaymentMethod = true;
        break;
      }
    }

    var instructions = this.props.extras.pass.RedeemQuantity + " " + this.props.extras.pass.Name;
    var totalPriceString = locManager.localizedStringForKey("TOTAL_LABEL") + "  " + locManager.localizedDollars(parseFloat(this.props.extras.pass.AmountCharged));

    return (
      <View style={styles.container}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height, backgroundColor: generalColor}]} />

        <ReUpScrollView ref="ptr" bounces={true} responder={this} refreshDisabled={this.state.refreshDisabled}>
          <View style={[styles.instructionContainer, {backgroundColor: instructionColor}]}>
            <View style={{alignSelf:'center'}}>
              <ReUpText appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                {instructions}
              </ReUpText>
            </View>
            <View style={{flex:1}} />
            <ReUpIconButton type={3}
              appManager={appManager}
              featureData={this.props.featureData}
              appActions={appActions}
              />
          </View>
          <ShadowView appManager={appManager} layout={this.state.layout} />
          <ReUpText appManager={appManager} isTitle={true} style={{color:generalTitleColor,margin:10, textAlign:'center'}}>
            {this.props.extras.pass.Description}
          </ReUpText>
          <ReUpText appManager={appManager} style={{color:generalTitleColor,margin:4, textAlign:'center'}}>
            {totalPriceString}
          </ReUpText>
          <PaymentMethodChooserView ref={"paymentMethod"} style={[styles.paymentMethodContainer,{marginBottom:10}]} appManager={appManager} appActions={appActions}
            initialLayout={this.state.layout} paymentInfo={paymentInfo}/>
          {
            hasPrimaryPaymentMethod ?
            <ReUpButton style={[styles.doneButton,{margin:10}]} appManager={appManager}
             text={purchaseButtonTitle}
              onPress={() => {
                AddPass.submit();
              }}
              />
            :
            null
          }
        </ReUpScrollView>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },

  // body

  bodyText: {
    margin:10,
    textAlign:'center',
  },

  alertTitle: {
    margin:4,
    textAlign:'center',
  },

  paymentMethodContainer: {
    flexDirection:'row',
    marginTop:0,
    marginBottom:0,
    marginLeft:0,
    marginRight:0,
    height:60,
    flex:1,
    alignItems:'center',
    justifyContent:'center'
  }
});

AddPass.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;
  var isLoggedIn = appManager.isLoggedIn();

  if( !isLoggedIn ) return [];
  else
  {
    var user = appManager.currentUser();
    var credit = parseFloat(user[ModelConstants.Credits]);

    var didSelect = function() {appActions.requestFeatureName("AddPass")};
    var iconName = featureData.data.icon.replace("fa-", "")
    return [{
      didSelect : didSelect,
      title : featureData.data.title,
      icon : iconName,
      cardType : 0,
      sortOrder : 0
    }];
  }
}


AddPass.dataDependencies = ["Users", "Passes"];

module.exports = AddPass;



// WEBPACK FOOTER //
// ./src/AddPass.js